import { useCallback, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router";

// Components
import { PageHeader } from "../components/PageSpecificComponents";
import { Tab, Card } from "../components/UI";

// Page components
import {
  GeneralSettings,
  ServiceTypeAndCapacity,
  ManageSchedule,
  ServiceMenu,
  StaffManagement,
  RolesAndPermissions
} from "../components/PageSpecificComponents/pagesComponents/generalBranchSettings";

// Builders
import { tabsBuilder } from "../builders/generalBranchSettings.builder";

// Constants
import * as tabsValues from "../constants/generalBranchSettingsTabs.constants";

// Styles
import { GeneralBranchSettingsStyles } from "../pagesStyles/general-branch-settings.styles";

const validTabs = Object.values(tabsValues);

const GeneralBranchSettings = () => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();

  const queryTab = new URLSearchParams(location.search).get("tab");
  const chosenTab = validTabs.includes(queryTab)
    ? queryTab
    : tabsValues.GENERAL_SETTINGS;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [chosenTab]);

  const setTab = useCallback(
    value => {
      history.replace({ search: `?tab=${value}` });
    },
    [history]
  );

  return (
    <GeneralBranchSettingsStyles>
      <PageHeader title="General Branch Settings" showBack />
      <div className="contentContainer">
        <div className="tabs">
          {tabsBuilder.map((tab, i) => (
            <Tab
              {...tab}
              isActive={tab.value === chosenTab}
              onClick={setTab}
              key={i}
            />
          ))}
        </div>
        <div className="cardContainer">
          {chosenTab === tabsValues.GENERAL_SETTINGS && (
            <GeneralSettings branchId={id} />
          )}
          {chosenTab === tabsValues.SERVICE_TYPE_AND_CAPACITY && (
            <Card rounded>
              <ServiceTypeAndCapacity branchId={id} />
            </Card>
          )}
          {chosenTab === tabsValues.MANAGE_SCHEDULE && (
            <Card rounded>
              <ManageSchedule branchId={id} />
            </Card>
          )}
          {chosenTab === tabsValues.SERVICE_MENU && (
            <ServiceMenu branchId={id} />
          )}
          {chosenTab === tabsValues.STAFF_MANAGEMENT && (
            <StaffManagement branchId={id} />
          )}
          {chosenTab === tabsValues.ROLES_AND_PERMISSIONS && (
            <RolesAndPermissions branchId={id} />
          )}
        </div>
      </div>
    </GeneralBranchSettingsStyles>
  );
};

export default GeneralBranchSettings;
